import Vue from "vue";
import { GyHeader } from "@/components/header";
import { GyFooter } from "@/components/footer";
import { GyLogo } from "@/components/logo";
import { GyDivider } from "@/components/divider";
import { GyNavigation } from "@/components/navigation";
import { GyIcon } from "@/components/icon";
import { GySteps, GyStep } from "@/components/steps";
import { GyInput } from "@/components/input";

Vue.component("GyHeader", GyHeader);
Vue.component("GyFooter", GyFooter);
Vue.component("GyLogo", GyLogo);
Vue.component("GyDivider", GyDivider);
Vue.component("GyNavigation", GyNavigation);
Vue.component("GyIcon", GyIcon);
Vue.component("GySteps", GySteps);
Vue.component("GyStep", GyStep);
Vue.component("GyInput", GyInput);
